<template>
  <div class="stage-header" v-if="!isLoading">
    <b-navbar toggleable="md">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="left-menu">
          <b-nav-item-dropdown v-for="(route, index) in routes" :class="[ $route.path.indexOf(route.path) > -1 ? 'menuItem active' : 'menuItem']" v-bind:text="route.name" :key="index" no-caret>
            <div class="arrow"></div>
            <b-dropdown-item v-for="(rChild, childIndex) in route.children" :key="childIndex" @click="gotoPage(rChild)">
              <a tag="li"  class="submenu-item">{{rChild.name}}</a>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <a @click="gotoPage({page:'activityLog'})" class="nav-link" :class="[ $route.path.indexOf('activity') > -1 ? 'menuItem active' : 'menuItem']">Activity Log</a>
        </b-navbar-nav>
        <div class="ml-auto nav-action-btn-wrapper">
          <b-button class="reload-btn" variant="white" v-on:click="reload()" v-if="!isReloadProgress">
            <reload-icon class="icon-default reload"></reload-icon>
            <span>Reload Data</span>
          </b-button>
          <b-button class="reload-btn" variant="white" v-else @click="terminateReloadData">
            <reload-icon class="icon-default reload" v-bind:class="{inprogress:isReloadProgress}"></reload-icon>
            <span v-if="currentReloadProgress">{{currentReloadProgress.loaded}} / {{currentReloadProgress.total}} sites
              <close-icon class="icon-default closedark"></close-icon>
            </span>
          </b-button>
          <label class="ago-time">
            <span v-if="isReloadProgress" class="loading"> Loading</span>
            <span v-else>
              {{lastReloadTime}}
            </span>
          </label>
        </div>
      </b-collapse>
    </b-navbar>
    <b-row class="middle-notification-container m-0" v-if="clientPluginUpdates.siteIDs">
      <b-col class="notification-content warning">
        <warning-icon class="icon-default warning"></warning-icon>
        <span class="text">An update to the IWP Client Plugin is available.
        </span>
        <span class="link-action" @click="showClientPluginUpdateModal"> Update on {{clientPluginUpdates.siteIDs.length}} {{ 'site' | pluralize(clientPluginUpdates.siteIDs.length)}} now.</span>
        <client-plugin-update ref="clientpluginupdate" :update="clientPluginUpdates"></client-plugin-update>
      </b-col>
    </b-row>
    <h1 class="page-title">{{ getPageTitle(this.$route.params.slug) }}</h1>
  </div>
</template>

<script>
import ReloadIcon from '../assets/reload.svg';
import WarningIcon from '../assets/warning.svg';
import CloseIcon from '../assets/close.svg';

import routes from '../router/routes';
import Utils from '../mixins/utils';

import clientPluginUpdate from './modals/ClientPluginUpdate';

export default {
  name: 'iwpnavbar',
  components: {
    ReloadIcon,
    WarningIcon,
    CloseIcon,
    clientPluginUpdate
  },
  props: ['isLoading'],
  data() {
    return {
      routes: [
        {
          name: 'Manage',
          children: [
            { name: 'Updates', page: 'updates' },
            { name: 'Plugins And Themes', page: 'pluginsAndThemes' }
          ]
        },
        {
          name: 'Protect',
          children: [{ name: 'Backups', page: 'backups' }]
        }
        // {
        //   name: 'Monitor',
        //   children: [{ name: 'Google Analytics', page: 'googleAnalytics' }]
        // }
      ],
      reloadSpinner: false
    };
  },
  watch: {
    isLoading(newVal, oldVal) {
      if (newVal === false) {
        let settings = this.$store.getters.getSettings;
        
        if (
          settings &&
          settings.appSettings &&
          settings.appSettings.enableReloadDataPageLoad === '1'
        ) {
          this.reload();
        }
      }
    }
  },
  computed: {
    siteUpdates() {
      return this.$store.getters.getSitesUpdates;
    },
    lastReloadTime() {
      return this.$store.getters.getLastReloadTime;
    },
    clientPluginUpdates() {
      return this.$store.getters.getClientPluginUpdateSites;
    },
    isReloadProgress() {
      let reloadProgress = this.$store.getters.getStateVariable(
        'currentReloadProgress'
      );
      if (_.isEmpty(reloadProgress)) return false;
      if (reloadProgress.loaded === reloadProgress.total) return false;
      return true;
    },
    currentReloadProgress() {
      if (this.isReloadProgress) {
        return this.$store.getters.getStateVariable('currentReloadProgress');
      }
      return false;
    }
  },
  methods: {
    gotoRoute(route) {
      this.$router.push({ name: route.name });
    },
    gotoPage(route) {
      this.$router.push({ name: 'Manage', params: { slug: route.page } });
    },
    showClientPluginUpdateModal() {
      this.$refs.clientpluginupdate.$refs.clientpluginupdate.show();
    },
    getPageTitle() {
      let currentSlug = this.$route.params.slug;
      if (currentSlug === 'activityLog') {
        return 'Activity Log';
      }
      if (currentSlug === 'loginActivity') {
        return 'Login Log';
      }
      let routes = [];
      _.each(this.routes, route => {
        routes = routes.concat(route.children);
      });
      return _.find(routes, { page: currentSlug }).name;
    },
    reload() {
      let payload = {};
      payload.action = 'getStats';
      payload.requiredData = {
        getSites: 1,
        getHistoryPanelHTMLV3: 1,
        getPluginsAndThemesV3: 1,
        getGroupsSitesV3: 1,
        getSitesUpdatesV3: 1,
        getSitesBackupsV3: 1,
        getClientUpdateAvailableSiteIDs: 1
      };
      this.$store
        .dispatch('sendAction', payload)
        .then(response => {
          
          let actionID = response.actionResult.actionID;
          this.$store.commit('SET_STATE_VARIABLE', {
            variable: 'currentReloadActionID',
            value: response.actionResult.actionID
          });
          let getWaitData = response.data.getWaitData;
          this.$store.commit('SET_STATE_VARIABLE', {
            variable: 'currentReloadProgress',
            value: {
              total: getWaitData[actionID].total,
              loaded: getWaitData[actionID].loaded
            }
          });
        })
        .catch(err => {
          
        });
    },
    terminateReloadData() {
      let payload = {
        requiredData: {
          terminatePendingProcess: {
            actionID: this.$store.getters.getStateVariable(
              'currentReloadActionID'
            )
          }
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue